export interface IWsUsuario {
    IdUsuario: string;
    Password: string;
    IdTipo: number;
    Detalle: string;
    Nombres: string;
    Correo: string;
    FlagActivo: boolean;
}

export class WsUsuario {
    IdUsuario: string;
    Password: string;
    IdTipo: number;
    Detalle: string;
    Nombres: string;
    Correo: string;
    FlagActivo: boolean;

    constructor(data?: IWsUsuario) {
        if (data) {
            this.IdUsuario = data.IdUsuario;
            this.Password = data.Password;
            this.IdTipo = data.IdTipo;
            this.Detalle = data.Detalle;
            this.Nombres = data.Nombres;
            this.Correo = data.Correo;
            this.FlagActivo = data.FlagActivo;
        }
    }
}
